import { FunctionField } from 'react-admin';
import PropTypes from 'prop-types';
import ActiveIcon from '@/assets/icons/active-icon.svg?react';
import DisactiveIcon from '@/assets/icons/disactive-icon.svg?react';

export const CustomBooleanField = ({ source }) => <FunctionField source={source} render={record => (record[source] ? <ActiveIcon /> : <DisactiveIcon />)} />;

CustomBooleanField.propTypes = {
    source: PropTypes.string.isRequired,
};
